export default __webpack_public_path__ + "static/media/notewrote.3a715536.png";